import type * as React from "react";
import { cn } from "@/lib/utils";

interface ReportHeaderProps {
  title: React.ReactNode;
  /**
   * Content to render below the title in the left column.
   * If not provided, no second row is rendered.
   */
  primary?: React.ReactNode;
  right?: React.ReactNode;
  /**
   * Additional content to render in the header, inline with the title.
   * Renders to the right of the title in the left-hand column.
   */
  headerExtras?: React.ReactNode;
  className?: string;
}

export function ReportHeader({
  title,
  primary,
  right,
  headerExtras,
  className,
}: ReportHeaderProps) {
  return (
    <div className={cn("shrink-0", className)}>
      <div className="grid grid-cols-1 gap-3 pt-4 md:grid-cols-[1fr_auto] md:items-start">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <h1 className="whitespace-nowrap font-heading">{title}</h1>
            {headerExtras && (
              <div className="flex items-center">{headerExtras}</div>
            )}
          </div>
        </div>

        <div
          className={cn(
            "min-w-0 md:row-start-1 md:col-start-2 md:justify-self-end",
            primary && "md:row-span-2",
          )}
        >
          {right ?? <div className="hidden md:block h-9 min-w-[250px]" />}
        </div>

        {primary && <div className="min-w-0">{primary}</div>}
      </div>
    </div>
  );
}
